import vtkLineManipulator from './LineManipulator';
import vtkPlaneManipulator from './PlaneManipulator';

export default {
  vtkLineManipulator,
  vtkPlaneManipulator,
};
